import { Provider } from '@angular/core';
import { PROPOSTA_FINANCIAMENTO_REPOSITORY } from './repositories/proposta-financiamento.repository';
import { PropostaFinanciamentoService } from './services/proposta-financiamento.service';

export const PROPOSTA_FINANCIAMENTO_PROVIDERS: Provider[] = [
  {
    provide: PROPOSTA_FINANCIAMENTO_REPOSITORY,
    useClass: PropostaFinanciamentoService
  }
];
